import queries from '@apis/queries';
import { useQuery } from '@tanstack/react-query';

function useProjects() {
    const { data } = useQuery(queries.project.list());
    return data?.projects;
}

export default useProjects;
